import React from 'react'
import { browserHistory, buildStudyRoutePath } from 'utils/navigation'
import MediaUpload from 'containers/mediaUploadContainer'
import {
  MEDIA_TYPE_MAP,
  MODAL_CLASSES_MAP,
  DATE_FORMAT_MAP,
  MODAL_CONTENT_MAP,
  MODAL_BUTTONS_MAP,
} from 'utils/constants'
import { getDateFromNow, getFormatDate } from 'utils/time'
import STRINGS from 'utils/strings'
import SelectStudyVersionModalContainer from '../containers/SelectStudyVersionModalContainer'
import { setStudyDurationForTimeline as setStudyDurationForTimelineSession } from 'utils/studyDurationForTimeline'
import { runStudyListNavigation } from '../utils/studyCardNavigation'

const StudyCard = ({
  study,
  mainStudyPage,
  hasWhiteLabelingEditPermissions,
  onUpload,
  uploadLogo,
  openModal,
  closeModal,
  deleteLogo,
  dateToString,
  tooltips,
  renderIcons,
  user,
  fetchStudyVersionList,
  fetchStudy,
}) => {
  const { id, platform_name, name, is_test, is_locked, created_on, config } = study

  const hasStudyPromotion = !!config?.study_promotion

  const openNotAvailableModal = () => {
    openModal({
      closeOnBackgroundClick: true,
      content: MODAL_CONTENT_MAP.theStudyIsNotAvailableYet,
      confirmButton: MODAL_BUTTONS_MAP.ok,
      className: `${MODAL_CLASSES_MAP.confirmation} ${MODAL_CLASSES_MAP.uatStudyConfirmation}`,
      hideCancelButton: true,
      onConfirm: closeModal,
    })
  }

  const navigateFromList = redirectPath => {
    runStudyListNavigation({
      hasStudyPromotion,
      userPermissions: user?.permissions,
      studyId: id,
      fetchStudyVersionList,
      onModal: () => {
        openModal({
          closeOnBackgroundClick: true,
          content: <SelectStudyVersionModalContainer studyId={id} redirectPath={redirectPath} />,
          className: `select-study-version-modal`,
          noButtons: true,
        })
      },
      onGo: versionId => {
        if (fetchStudy) fetchStudy(id)
        browserHistory.push(buildStudyRoutePath(id, versionId, redirectPath))
      },
      onUnavailable: openNotAvailableModal,
    })
  }

  return (
    <div
      onClick={() => {
        setStudyDurationForTimelineSession({ study_duration: study.study_duration })
        navigateFromList(mainStudyPage || 'compliance')
      }}
      className='study-box clickable'
      key={`study_${platform_name}_${id}`}
      id={`study-${id}`}
      type='button'>
      <div className='sticker-container'>
        <span className='study-id'>{`ID ${id}`}</span>
        <div
          style={{
            display: 'flex',
          }}>
          {is_test && <div className='test'>{STRINGS.test}</div>}
          {is_locked && (
            <span className='lock sticker'>
              <i className='fa fa-lock' />
            </span>
          )}
        </div>
      </div>
      <div style={{ flexGrow: 1 }}>
        <div className='participant-box'>
          <div className={`logo ${study['custom-logo'] ? 'img' : 'symbol'}`}>
            {hasWhiteLabelingEditPermissions && (
              <div
                className='tools'
                onClick={e => {
                  e.preventDefault()
                  e.stopPropagation()
                }}>
                <span
                  className='tool-button tool-pencil'
                  onClick={e => {
                    e.stopPropagation()
                    openModal({
                      content: (
                        <MediaUpload
                          className='photo-submission'
                          confirmButton={STRINGS.submit}
                          mediaTypes={[MEDIA_TYPE_MAP.image]}
                          noTabs
                          heading={STRINGS.provideExampleImages}
                          subheading={STRINGS.uploadImage}
                          noAltTextReq
                          callback={onUpload}
                          uploadImage={uploadLogo}
                          uploadOptions={{ method: study['custom-logo'] ? 'PUT' : 'POST' }}
                          studyID={id}
                          showButtons
                          isCrop
                          previmSrc={study['custom-logo'] || null}
                          changeImageMode={!!study['custom-logo']}
                          initTab='white_labeling'
                        />
                      ),
                      className: MODAL_CLASSES_MAP.photoSubmissionUploader,
                      closeOnBackgroundClick: false,
                      noButtons: true,
                    })
                  }}>
                  <i className='fas fa-pencil-alt' />
                </span>
                {study['custom-logo'] && (
                  <span className='tool-button trash-icon'>
                    <i className='fas fa-trash-alt' onClick={() => deleteLogo(id)} />
                  </span>
                )}
              </div>
            )}
            {study['custom-logo'] ? (
              <img alt='logo' src={study['custom-logo']} loading='lazy' />
            ) : (
              <span className='char'>{platform_name.charAt(0)}</span>
            )}
          </div>
          <div className='info'>
            <div>
              <i className='far fa-calendar-alt' />
              <span>{`${dateToString} ${STRINGS.study}`}</span>
            </div>
          </div>
        </div>
        <h5 className='word-clamp'>{platform_name}</h5>
        <h6>{name}</h6>
      </div>
      <div className='card-foot flexed'>
        <div className='date-created'>
          <p>{`${STRINGS.created} ${getDateFromNow(created_on)}`}</p>
          <div className='hover-text'>{getFormatDate(created_on, DATE_FORMAT_MAP.mainWithTime)}</div>
        </div>
        <div className='foot-icons'>
          {tooltips.map(tooltip => renderIcons(id, tooltip, hasStudyPromotion))}
        </div>
      </div>
    </div>
  )
}

export default StudyCard
